/**
 * @file Testimonial List.
 */

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Testimonial List component.
 */
const vTestimonialList = () => {
	const testimonialList = document.querySelector('.v-testimonial-list');

	if (!testimonialList) {
		return;
	}

	gsap.registerPlugin(ScrollToPlugin);

	const testimonials = testimonialList.querySelectorAll('.v-testimonial-list__item');

	// Scroll to and activate the testimonial from hash
	if (window.location.hash) {
		const hash = window.location.hash.substring(1).replace('testimonial-', '');
		const targetTestimonial = [...testimonials].filter((t) => t.dataset.hash === hash)[0];

		if (targetTestimonial) {
			gsap.to(window, {
				duration: 0.75,
				scrollTo: {
					y:        targetTestimonial.getBoundingClientRect().top + window.pageYOffset,
					offsetY:  50,
					autoKill: false,
				},
			});
		}
	}
};

export default vTestimonialList;
